module.exports = __webpack_public_path__ + "img/crinverlogin.fbb6694d.jpg";